<template>
  <div class="page-buttons" v-if="list.length>1">
    <span class="prev-button" @click="changePage('prev')" :class="activeIndex==0 ? 'disabled' :'' ">
  	  <img src="../../static/prevBtn2.png"/>
    </span>
    <span :class="activeIndex==list.length-1 ? 'disabled':''"  class="next-button" @click="changePage('next')">
    		<img src="../../static/nextBtn2.png"/>
    </span>
    <!-- <button :class="{disabled:activeIndex!=imgList.length-1}" class="next-button" @click="changePage('next')">&gt;</button> -->
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data(){
  	return{
  		activeIndex: 0
  	}
  },
  computed: {
    visiblePrev() {
      return this.list.length > 1
    },
    visibleNext() {
      return this.list.length > 1
    }
  },
  methods:{
  	changePage(type){
  		this.activeIndex = type==='prev' ? this.activeIndex-1 : this.activeIndex+1 ;
		this.$parent.setActiveItem(this.activeIndex)
  	},
  	closeModal(){
  		this.$parent.hideModal();
  	},
  }
 
};
</script>

<style lang="less">
@import '../assets/css/index';
@import '../assets/css/style';
.page-buttons {
	  position: absolute;
	  top: 85.4% !important;
	  left: 9.3%;
	  display: flex;
	  align-items: baseline;
	  z-index: 10;
	  .prev-button,.next-button{
		   // .scale(31*180/63,31);
		   .scale(43*180/63,43);
		   line-height: 0;
		   &.disabled{
				// background: rgba(255, 255, 255, 0.2);
				cursor: not-allowed;
				// filter: brightness(0.5);
				filter: grayscale(1);
				pointer-events: none;
				// background: rgba(255, 255, 255, 0) !important;
		   }
	  }
	  span{
		 .scale(13,13);
		  border-radius: 50%;
		  display: inline-block;
		  // background-color: #8b8b8b;
		  margin: 0 10/@r;
		  &.active{
			  .scale(31,13);
			  background-color: #fff;
			  border-radius: 10px;
		  }
	  }
	}
</style>
